




















import VueOptions from '@utils/VueOptions'

settings =
  name: 'IntroTutorialStep'

export default VueOptions.vue settings
